import { useSearchParams } from 'react-router-dom'

export default function SupportActionPage() {
  const [params] = useSearchParams()
  const result = params.get('result')
  const to = params.get('to')

  const states: Record<string, { title: string; body: string }> = {
    sent: {
      title: 'Reply sent',
      body: to ? `Your reply was sent to ${to}.` : 'Your reply was sent successfully.',
    },
    rejected: {
      title: 'Ticket closed',
      body: 'The draft was rejected and the ticket is marked closed.',
    },
    already_actioned: {
      title: 'Already actioned',
      body: 'This link has already been used. Nothing to do.',
    },
    not_found: {
      title: 'Link not found',
      body: 'This link is invalid or has expired.',
    },
    error: {
      title: 'Something went wrong',
      body: 'The email could not be sent. Try again or send manually from your email client.',
    },
    config_error: {
      title: 'Configuration error',
      body: 'Email sending is not configured. Set RESEND_API_KEY in Supabase secrets.',
    },
  }

  const state = states[result ?? ''] ?? {
    title: 'Unknown result',
    body: 'Something unexpected happened.',
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="max-w-sm w-full space-y-3">
        <h1 className="text-xl font-semibold">{state.title}</h1>
        <p className="text-muted-foreground text-sm">{state.body}</p>
        <p className="text-xs text-muted-foreground pt-2">
          <a href="/" className="text-primary underline underline-offset-2">
            ← RoleRound
          </a>
        </p>
      </div>
    </div>
  )
}
